import { helpbuttonStyle, convertToLocalStyle } from '@bingads-webui-campaign-react/common-styles';

export const getPanelStyles = ({ palette = {} }) => ({
  '@global': {
    '.side-panel-dynamic-target.panel-right .panel-content': {
      '& .panel-body': {
        width: 600,
        paddingLeft: 20,
        paddingRight: 24,
        display: 'flex',
        height: 'calc(100% - 56px)',
        overflowX: 'hidden',
        overflowY: 'scroll',
        marginBottom: 65,
      },
      '& .panel-header': {
        paddingLeft: 24,
        '& .panel-title': {
          fontSize: 22,
        },
      },
      '& .react-block-ui-none, .react-block-ui': {
        display: 'flex',
        height: '100%',
      },
      ...convertToLocalStyle(helpbuttonStyle({ palette })),
    },
  },
  flexContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
});
